import script from "./CheckoutTurnstile.vue?vue&type=script&setup=true&lang=ts"
export * from "./CheckoutTurnstile.vue?vue&type=script&setup=true&lang=ts"

import "./CheckoutTurnstile.vue?vue&type=style&index=0&id=8ed4c038&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ed4c038"]])

export default __exports__